// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"de5912e7","516":"52dc75f5","662":"d3e8bf73","765":"2fcbb79c","780":"98231183","889":"01ba0653","956":"307a7b76"}[chunkId] + ".js";
};